import {defaultTheme} from "@digisthesia/remix-utils/mantine.config";
import {MantineThemeOverride} from "@mantine/core";

export const HexploitTheme: MantineThemeOverride = {
  ...defaultTheme,
  primaryColor: "grape",
};
